//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {deleteRoomOwnerCar, getRoomOwnerCarsByRoomId, createRoomOwnerCar} from '../../../../api/newOwner';

export default {
  name: 'page-detail-car',
  props: {
    roomId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      deleting: false,
      saving: false,
      createCarModal: false,
      carInputDto: {
        id: 0
      },
      carList: [],
      rules: {
        carNum: [{required: true, message: '请输入车牌号', trigger: 'blur'}]
      },
      carColumns: [
        {type: 'index', align: 'center', width: 60},
        {title: '车牌号', align: 'center', key: 'carNum'},
        {title: '品牌', align: 'center', key: 'carBrand'},
        {title: '型号', align: 'center', key: 'carModel'},
        {title: '颜色', align: 'center', key: 'carColor'},
        {title: '经常驾驶此车的人士', align: 'center', key: 'driver'},
        {
          title: '是否常用', align: 'center', key: 'isCommonlyUsed',
          render: (h, params) => {
            return h('span', params.row.isCommonlyUsed ? '是' : '否');
          }
        },
        {title: '操作', align: 'center', slot: 'actions'}
      ]
    };
  },
  methods: {
    getRoomOwnerCarsByRoomId() {
      getRoomOwnerCarsByRoomId(this.roomId).then(res => {
        this.carList = [];
        this.carList.push(...res.data.result);
      });
    },
    editCar(row) {
      this.carInputDto = {};
      this.carInputDto = JSON.parse(JSON.stringify(row));
      this.createCarModal = true;
    },
    handleDelCar(row) {
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认解除？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          this.deleting = true;
          deleteRoomOwnerCar(row.id).then(res => {
            this.$Notice.success({
              title: '提示',
              desc: '删除成功'
            });
            this.getRoomOwnerCarsByRoomId();
          }).finally(() => {
            this.deleting = false;
          });
        }
      });
    },
    onCancel() {
      this.carInputDto = {};
      this.createCarModal = false;
    },
    onSave() {
      // this.carInputDto.memberId = this.memberInfo.id;
      this.carInputDto.roomId = this.roomId;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saving = true;
          createRoomOwnerCar(this.carInputDto).then(res => {
            this.createCarModal = false;
            this.getRoomOwnerCarsByRoomId();
          }).finally(() => {
            this.saving = false;
          });
        }
      });


    }
  },
  created() {
    this.getRoomOwnerCarsByRoomId();
  },
  watch: {
    roomId() {
      if (this.roomId > 0) {
        this.getRoomOwnerCarsByRoomId();
      }
    }
  }
};
